import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "カフェレオ", enum: "CAFEREO" },
  { value: 2, text: "メーカー", enum: "MAKER" },
]);
